import { render, staticRenderFns } from "./Intervention.vue?vue&type=template&id=a5d71678&scoped=true"
import script from "./Intervention.vue?vue&type=script&lang=js"
export * from "./Intervention.vue?vue&type=script&lang=js"
import style0 from "./Intervention.vue?vue&type=style&index=0&id=a5d71678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d71678",
  null
  
)

export default component.exports